/**
 * @packageDocumentation
 * @module f1/array
 */

export interface Union {
  /**
   * Calculate the union of two arrays, and results in a unique list of values
   *
   * @public
   * @function f1.union
   * @param aug an augmented list of values
   * @param arr a list of values
   * @example
   *
   * ```ts
   * f1.union([1, 3, 4], [1, 2, 1, 3, 3]) => [1, 2, 3, 4]
   * ```
   *
   */
  <T>(aug: T[], arr: T[]): T[];
  <T>(aug: T[]): (arr: T[]) => T[];
}

/**
 * @see Union
 */
export default <T>(aug: T[], arr: T[]): T[] => {
  return [...new Set(arr.concat(aug))];
};
